import { put, takeEvery } from "redux-saga/effects";
import { isMobile } from "react-device-detect";

import lobbyService from "../../../../services/casino/lobby";
import {
  getFavoritesStart,
  getFavoritesSuccess,
  getFavoritesFailure,
  addRemoveFavoritesStart,
  addRemoveFavoritesSuccess,
  addRemoveFavoritesFailure
} from "../../../redux/casino/lobby/favorites";
import { showErrorMessage, showSuccessMessage } from "../../../redux/toast";

function* favoritesWatcher() {
  yield takeEvery(
    [getFavoritesStart.type, addRemoveFavoritesStart.type],
    favoritesWorker
  );
}

function* favoritesWorker(action) {
  try {
    switch (action.type) {
      case getFavoritesStart.type: {
        const { data, error } = yield lobbyService.getfavorites({
          ...action.payload,
          loadMoreFavorites: null,
          searchGames: null
        });
        if (!error) {
          yield put(
            getFavoritesSuccess({
              favorites: data?.games,
              numberOfPages: data?.numberOfPages || 0,
              favoritesCount: data?.queriedCount || 0,
              loadMoreFavorites: action.payload?.loadMoreFavorites,
              searchGames: action?.payload?.searchGames,
              favoritePage: action.payload.page
            })
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getFavoritesFailure());
        }
        break;
      }

      case addRemoveFavoritesStart.type: {
        const resObj = JSON.parse(JSON.stringify(action.payload));
        delete resObj?.recallFav;
        const { data, error } = yield lobbyService.addRemoveFavorites(resObj);
        if (!action.payload?.favStatus) {
          yield put(showSuccessMessage({ tKey: "LOBBY.GAME_ADDED_TO_FAV" }));
        } else {
          yield put(
            showSuccessMessage({ tKey: "LOBBY.GAME_REMOVED_FROM_FAV" })
          );
        }

        if (!error) {
          if (action.payload?.recallFav) {
            yield put(
              getFavoritesStart({
                limit: action.payload?.recallFav || 12,
                page: 1,
                isMobile
              })
            );
          }
          yield put(addRemoveFavoritesSuccess(data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(addRemoveFavoritesFailure());
        }
        break;
      }

      default: {
        break;
      }
    }
  } catch (error) {
    switch (action.type) {
      case getFavoritesStart.type: {
        yield put(getFavoritesFailure());
        break;
      }
      case addRemoveFavoritesStart.type: {
        yield put(addRemoveFavoritesFailure());
        break;
      }

      default:
        break;
    }
    yield put(showErrorMessage({ msg: error.message }));
  }
}

export default favoritesWatcher;
